import React from "react";
import HomeLayout from "../../commonComponents/HomeLayout";
import OurStory from "./components/OurStory";
import TheTeam from "./components/TheTeam";
import NextHomeSection from "../ContactUs/components/NextHomeSection";

const index = () => {
  return (
    <HomeLayout showMarquee={false}>
      <div className="flex flex-col gap-5">
        <div className="flex flex-col pt-8 pb-8 gap-10 lg:px-6 pt-16 lg:px-16">
          <section className="w-full bg-primary shadow-cardShadow py-10 lg:pt-5 lg:pb-10 px-6 lg:px-14 flex flex-col items-center justify-center gap-6">
            <h2 className="font-medium text-[28px] leading-[100%] text-white">
              Our Team
            </h2>
            <span className="text-textWhite text-[16px] font-exo lg:text-[20px] leading-[22px] lg:leading-[32px] text-center max-w-[802px]">
              A dedicated team turning visions into keys, and houses into homes.
            </span>
          </section>
          <OurStory />
          <TheTeam />
        </div>
        <NextHomeSection />
      </div>
    </HomeLayout>
  );
};

export default index;
